import { render } from "./CompanyEdit.vue?vue&type=template&id=74e98dea&scoped=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&lang=js"

import "./CompanyEdit.vue?vue&type=style&index=0&id=74e98dea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e98dea"]])

export default __exports__